import React from 'react';
import { scrollToPurchase } from '../utils/checkout';
export function BonusesSection() {
  const bonuses = [{
    num: 1,
    title: '30 Sit-Snap-Shoot Cheat Sheets',
    desc: '30 simple photo recipes you can follow step by step with your own dog.',
    img: 'https://cdn.magicpatterns.com/uploads/49zvbTkdjAqvHwwBQTgzBH/Untitled_design_(1).png',
    value: '99'
  }, {
    num: 2,
    title: '7 Lightroom Editing Walkthroughs',
    desc: 'Simple editing guidance to make your dog photos look cleaner, warmer, and more polished.',
    img: 'https://cdn.magicpatterns.com/uploads/3NDmUJE4RXRqg5ohZ3mbCc/Untitled_design_(2).png',
    value: '149'
  }, {
    num: 3,
    title: 'Photo Settings & Setup Guide for 119 Dog Photos',
    desc: 'A practical reference guide that shows you what setup, light, and phone mode work best for different kinds of dog photos.',
    img: 'https://cdn.magicpatterns.com/uploads/isApy6HmHRdLWE3CjxjeFD/Untitled_design_(3).png',
    value: '99'
  }];
  return <section className="bg-black py-20 md:py-32 px-4 text-white" data-id="element-20">
      <div className="max-w-5xl mx-auto" data-id="element-21">
        <div className="text-center mb-16" data-id="element-22">
          <h2 className="font-serif text-5xl md:text-6xl font-bold text-soft-gold mb-4" data-id="element-23">
            🎁 Special Bonuses
          </h2>
          <h3 className="font-sans text-2xl md:text-3xl font-bold tracking-wider uppercase mb-2" data-id="element-24">
            BONUSES INCLUDED TODAY
          </h3>
          <p className="font-sans text-xl text-gray-300 italic" data-id="element-25">
            (At no extra cost)
          </p>
        </div>

        <div className="space-y-16 md:space-y-24" data-id="element-26">
          {bonuses.map(bonus => <div key={bonus.num} className="bg-gray-900 rounded-3xl p-8 md:p-12 border border-soft-gold/30 shadow-2xl flex flex-col md:flex-row items-center gap-10" data-id="element-27">
              <div className="md:w-1/2 w-full" data-id="element-28">
                <div className="inline-block bg-red-600 text-white font-bold px-4 py-1 rounded-full mb-6 text-sm tracking-wider uppercase animate-pulse" data-id="element-29">
                  FREE TODAY
                </div>
                <h3 className="font-serif text-3xl md:text-4xl font-bold text-white mb-4 leading-tight" data-id="element-30">
                  <span className="text-soft-gold" data-id="element-31">
                    🎁 Bonus #{bonus.num} –
                  </span>
                  <br data-id="element-32" />
                  {bonus.title}
                </h3>
                <p className="font-sans text-xl text-gray-300 mb-8 leading-relaxed" data-id="element-33">
                  {bonus.desc}
                </p>
                <div className="bg-black/50 p-6 rounded-xl border border-gray-800 inline-block w-full md:w-auto" data-id="element-34">
                  <p className="font-sans text-gray-400 text-lg line-through mb-1" data-id="element-35">
                    Value: USD ${bonus.value}
                  </p>
                  <p className="font-sans text-2xl font-bold text-green-400" data-id="element-36">
                    TODAY: FREE
                  </p>
                </div>
              </div>

              <div className="md:w-1/2 w-full cursor-pointer group" onClick={scrollToPurchase} data-id="element-37">
                <a href="#purchase" onClick={scrollToPurchase} className="block relative" data-id="element-38">
                  <img src={bonus.img} alt={`Bonus ${bonus.num}: ${bonus.title}`} className="w-full max-w-[540px] mx-auto aspect-square object-cover rounded-2xl shadow-xl border-2 border-gray-800 transition-transform duration-500 group-hover:scale-105 group-hover:border-soft-gold" data-id="element-39" />
                  <div className="absolute inset-0 bg-soft-gold opacity-0 group-hover:opacity-10 transition-opacity duration-500 rounded-2xl" data-id="element-40"></div>
                </a>
              </div>
            </div>)}
        </div>

        <div className="mt-20 text-center" data-id="element-41">
          <p className="font-serif text-3xl md:text-4xl font-bold text-soft-gold italic" data-id="element-42">
            These bonuses are FREE today only.
          </p>
        </div>
      </div>
    </section>;
}